export const trimTagValue = (value: any) => (typeof value === 'string' ? value.trim() : value);
